export default __webpack_public_path__ + "static/media/arrow_tip_dark.788c0c9d.svg";